export default function PublicFooter() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display font-black text-2xl tracking-tighter text-slate-900">IAVA</div>
          <div className="label-eyebrow mt-1">International Aviation Verification</div>
          <p className="mt-5 text-sm text-slate-600 max-w-md leading-relaxed">
            An independent verification platform for aviation credentials.
            Each certificate carries a unique number and QR code that can be
            authenticated against the IAVA registry in seconds.
          </p>
        </div>
        <div>
          <div className="label-eyebrow">Registry</div>
          <ul className="mt-4 space-y-2 text-sm text-slate-600">
            <li>Cabin Operations</li>
            <li>Safety &amp; Emergency</li>
            <li>Ground Operations</li>
            <li>Passenger Services</li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow">References</div>
          <ul className="mt-4 space-y-2 text-sm text-slate-600">
            <li>ICAO Annex 1</li>
            <li>EASA Part-CC</li>
            <li>IATA AHM / DGR</li>
            <li>ISO/IEC 27001</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between text-xs text-slate-500 font-mono-plex">
          <span>© {new Date().getFullYear()} IAVA. Independent verification platform.</span>
          <span>Registry build 26.02</span>
        </div>
      </div>
    </footer>
  );
}
